import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ILoyaltyField {
	changeLoyalty: (value: string) => void;
}

const LoyaltyField: React.FC<ILoyaltyField> = ({ changeLoyalty }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterLoyalty') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			changeLoyalty(onlyDigits);
			return onlyDigits;
		},
		[changeLoyalty],
	);

	return (
		<FormInput
			testId="LoyaltyField"
			name="loyalty"
			label="loyaltyLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(LoyaltyField);
